<template>
  <v-container fluid grid-list-md>
    <v-card>
      <v-form id="profile">
        <v-flex style="display: flex">
          <v-text-field
            name="email"
            v-model="email"
            v-validate="'email'"
            :label="this.$vuetify.t('$vuetify.AdminUsers.formEmail')"
          ></v-text-field>
          <v-btn
            dark
            color="green darken-1"
            form="check-profile-form"
            @click.stop="updateProfile">{{ $vuetify.t('$vuetify.UserSettings.save') }}
          </v-btn>
        </v-flex>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import api from '@/api'

export default {
  $_veeValidate: { validator: 'new' },
  name: 'ProfileSettings',
  data () {
    return {
      email: this.$store.getters.user.profile.email
    }
  },
  methods: {
    updateProfile () {
      this.$validator.validate()
        .then(isFormValid => {
          // Do nothing if validation fails -  errors are displayed in UI
          if (!isFormValid) {
            this.$emit('snackbar')
          } else {
            api.user.updateEmail(this.$store.getters.user.profile.id, this.email)
              .then(res => {
                this.$store.commit('SET_EMAIL', this.email)
              })
              .catch(
                () => {
                  this.isFormValid = false
                  this.$emit('snackbar')
                }
              )
          }
        })
    }
  }
}
</script>

<style scoped>

</style>
